module.exports = __webpack_public_path__ + "img/chat_on.e64f4408.svg";